import { Injectable } from '@angular/core';
import { RolePermission } from '../models/role-permission';
import { UserGroup } from '../../user-management/models/user-access-request';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApplicationStorageService {
  currentRegion: BehaviorSubject<any> = new BehaviorSubject(null);
  currentRegion$ = this.currentRegion.asObservable();

  emitCurrentRegion(change: string) {
    this.currentRegion.next(change);
  }

  constructor() { }
  getUserDetails() {
    const user = sessionStorage.getItem('userDetails');
    return user ? JSON.parse(user) : null;
  }
  setUserDetails(userDetails: any) {
    sessionStorage.setItem("userDetails", JSON.stringify(userDetails));
  }

  getSelectedRegion() {
    if (sessionStorage.getItem("sectortype") == "single") {
      return sessionStorage.getItem("selectedRegion");
    }
    return "";
  }
  setSelectedRegion(regionName: string) {
    if (sessionStorage.getItem("sectortype") == "single") {
      sessionStorage.setItem("selectedRegion", regionName);
      this.emitCurrentRegion(regionName);
    }
  }

  getUserAppName() {
    return sessionStorage.getItem('userAppName');
  }
  setUserAppName(appName: string) {
    sessionStorage.setItem("userAppName", appName);
  }


  setAllRolePermissions(rolePermission: RolePermission[]) {
    sessionStorage.setItem("rolePermissions", JSON.stringify(rolePermission));
  }

  getAllRolePermissions() {
    const rolePermissions = sessionStorage.getItem('rolePermissions');
    return rolePermissions ? JSON.parse(rolePermissions) : null;
  }
  setUserGroups(groups: any[]) {
    sessionStorage.setItem("usergroups", JSON.stringify(groups));
  }
  getUserGroups(): UserGroup[] {
    const usergroups = sessionStorage.getItem('usergroups');
    return (usergroups ? JSON.parse(usergroups) : null) as UserGroup[];
  }
  setSectorViewType(type: string) {
    sessionStorage.setItem("sectortype", type);
  }
  getSectorViewType() {
    return sessionStorage.getItem("sectortype");
  }
  clearAll() {
    sessionStorage.clear();
    localStorage.clear();
  }

  setProjectDetails(project: any) {
    sessionStorage.setItem("projectDetails", JSON.stringify(project));
  }
  getProjectDetails() {
    const project = sessionStorage.getItem('projectDetails');
    return project ? JSON.parse(project) : null;
  }
  isMultiTypeApp() {
    return sessionStorage.getItem("sectortype") == "single" ? false : true;
  }
}
